import axios from "axios";

/**
 * Trigger Excel download from an API endpoint.
 * Reads filename from Content-Disposition (UTF-8 RFC 5987) or falls back.
 * @param {string} url - API endpoint
 * @param {object} params - query params { year, agentCode }
 * @param {string} fallbackFilename - used if server doesn't send Content-Disposition
 * @param {string} authToken - bearer token (optional, for axios config)
 * @returns {Promise<void>}
 */
export async function exportExcelFromApi(url, params, fallbackFilename, authToken) {
    const response = await axios({
        url,
        method: "GET",
        params,
        responseType: "blob",
        headers: authToken ? { Authorization: "Bearer " + authToken } : {}
    });

    // Parse filename from Content-Disposition
    const cd = response.headers["content-disposition"] || "";
    let filename = fallbackFilename || "report.xlsx";
    const m1 = /filename\*=UTF-8''([^;]+)/i.exec(cd);
    const m2 = /filename="?([^";]+)"?/i.exec(cd);
    if (m1) {
        try { filename = decodeURIComponent(m1[1]); } catch (e) { /* keep fallback */ }
    } else if (m2) {
        filename = m2[1];
    }

    const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
}



// WEBPACK FOOTER //
// ./App/Shared/exportExcelHelper.js